<template>
	<div id="mainContainer" style="margin-top: -1rem;">
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search >
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label>用户号</label>
			<a-input v-model="customerNum" style="width: 7rem;margin: 0 0.525rem;"/>
			<label >支付宝缴费号</label>
			<a-input v-model="alipayNum" style="width: 8rem;margin: 0 0.525rem;"/>
			<a-button size="small"    icon="search" @click="queryCustomerByNum" :loading="searchNumFlag">查找</a-button>
			<a-button  size="small"   @click="showUpdateCustomerInfoFlag = true;" style="margin:0 0.525rem 0 2.2rem;">更新用户资料</a-button>
			<a-button  size="small"   @click="changePrepaySignFlag=true" style="margin:0  0.525rem 0 0">预后付费转换</a-button>
			<a-button  size="small"   @click="doCharge" style="margin:0  1.5rem 0 0">缴费</a-button>
			<a-button  size="small"   @click="showPrePaySignLogFlag = true" style="margin:0  0.525rem 0 0">预后付费转换历史</a-button>
			<label>IC卡</label>
			<a-input v-model="icCard" style="width: 7rem;margin: 0 0.525rem;"/>
			<a-button  size="small"   icon="search" @click="queryCustomerByCard" :loading="searchICCardFlag">查找</a-button>
		</div>
		<span class="titleInfo">用户信息</span>
		<div id="customerInfoDiv">
			<a-row style="height: 2.5rem;">
				<a-col :span="5">
						<label>水费号：</label>
						<a-input :disabled="true" style="width: 10.5rem;height: 1.5rem;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.pId"/>
				</a-col>
				<a-col :span="5">
					<label>用户号：</label>
					<a-input :disabled="true"  style="width: 10.5rem;height: 1.5rem;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.customerNum"/>
				</a-col>
				<a-col :span="5">
					<label>给水号：</label>
					<a-input :disabled="true"  style="width: 10.5rem;height: 1.5rem;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.apId"/>
				</a-col>
				<a-col :span="5">
					<label>用水类型：</label>
					<a-input :disabled="true"  style="width: 10.5rem;height: 1.5rem;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.houseKindName"/>
				</a-col>
			</a-row>
			<a-row style="height: 2.5rem;">
				<a-col :span="5">
					<label>用户名：</label>
					<a-input style="width: 10.5rem;height: 1.5;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.customerName"/>
				</a-col>
				<a-col :span="5">
					<label>手机：</label>
					<a-input   style="width: 10.5rem;height: 1.5;margin-left: 0.9rem;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.customerMobile"/>
				</a-col>
				<a-col :span="5">
					<label>身份证：</label>
					<a-input  style="width: 10.5rem;height: 1.5;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.nationalId"/>
				</a-col>
				<a-col :span="5">
					<label>水表状态：</label>
					<a-input :disabled="true"  style="width: 10.5rem;height: 1.5;color:black;font-size: 0.6875rem;" v-model="theMeterInfo.MeterStateName"/>
				</a-col>
			</a-row>
			<a-row style="height: 2.5rem;">
				<a-col :span="10">
					<label> 地址： </label>
					<a-input :disabled="true" style="width:25.3rem;height: 1.5;margin-left: 0.55rem;font-size: 0.6875rem;" v-model="theCustomerInfo.customerAddr"/>
				</a-col>
				<a-col :span="10">
					<label> 发票备注： </label>
					<a-input  style="width:25rem;height: 1.5;font-size: 0.6875rem;" v-model="theCustomerInfo.fpRemark"/>
				</a-col>
			</a-row>
			<a-row style="height: 2.5rem;">
				<a-col :span="5">
					<label>预付费：</label>
					<a-input :disabled="true" style="width: 10.5rem;height: 1.5;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.prePaySignName"/>
				</a-col><strong></strong>
				<a-col :span="5">
					<label>余额：</label>
					<a-input :disabled="true"  style="width: 10.5rem;height: 1.5;margin-left: 0.9rem;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.customerBalance"/>
				</a-col>
				<a-col :span="5">
					<label>户数：</label>
					<a-input :disabled="true"  style="width: 10.5rem;height: 1.5;margin-left: 0.9rem;color:black;font-size: 0.6875rem;" v-model="theCustomerInfo.peoplecnt"/>
				</a-col>
				<a-col :span="5">
					<label>余额阀值：</label>
					<a-input :disabled="true"  style="width: 10.5rem;height: 1.5;color:black;font-size: 0.6875rem;"  v-model="theCustomerInfo.warnThre"/>
				</a-col>
			</a-row>
		</div>
		<span class="titleInfo">水表信息</span>
		<div id = "meterInfoDiv">
			<div style="display: flex; flex-direction: row;align-items: center;margin-bottom: 0.625rem;">
				<label>新单价</label>
				<a-select style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="thePrice"  label-in-value>
					<a-select-option v-for="(item,index) in priceList" :key="item.PID"  :value="item.PID">{{item.PriceKindName}}</a-select-option>
				</a-select>
			</div>
			<a-table size="small" :columns="meterColumns" :data-source="theMeterList"  bordered  rowKey="PID" :pagination="false">
				<span slot="ValveStateSlot" slot-scope="text, record">
					{{getOpenType(record.ValveState)}}
				</span>
				<span slot="readTimeSlot" slot-scope="text, record">
					{{getTimeFormatter(record.readtime)}}
				</span>
				<span slot="meterSolidSlot" slot-scope="text, record">
					{{getSolidType(record.MeterSolid)}}
				</span>
				<span slot="deductionStyleSlot" slot-scope="text, record">
					{{getDeductionStyle(record.DeductionStyle)}}
				</span>
				<span slot="timerSwitchSlot" slot-scope="text, record">
					{{getOpenType(record.TimerSwitch)}}
				</span>
				<span slot="theAction" slot-scope="text, record">
					<a-popconfirm title="确认更新单价?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="updatePrice(record)">
						<a-button size="small" type="link" :disabled="Object.keys(thePrice).length == 0">更新单价</a-button>
					</a-popconfirm>
					<a-button size="small"  type="link" @click="updateDeRead(record)">更新扣费读数</a-button>
					<a-button size="small"  type="link" @click="showDeRead(record)">水表曲线</a-button>
					<a-button size="small"  type="link" @click="showPriceUpdateLogList(record)" >单价修改历史</a-button>
				</span>
			</a-table>
			<a-modal title="更新用户信息" :visible="showUpdateCustomerInfoFlag" :confirm-loading="confirmLoading"
							@ok="updateCustomerSubmit" @cancel="updateCustomerCancel">
				<UpdateCustomerInfo :theInfo="theCustomerInfo"/>
			</a-modal>
			<a-modal title="更新扣费读数" :visible="showUpdateDereadFlag" :confirm-loading="confirmLoading1"
							@ok="updateDereadSubmit" @cancel="closeUpdateDereadModal">
				<label>新扣费读数：</label>
				<a-input-number v-model="theDeread" :min="0"  :precision="0" style="width:15rem;"/>
			</a-modal>
			<a-modal title="缴费" :visible="showChargeFlag" :confirm-loading="confirmLoading2" 
							@ok="doChargeSubmit" @cancel="closeChargeModal">
				<div class="chargeDiv">
					<label>缴费时间：</label>
					<a-date-picker show-time placeholder="选择缴费时间"  @ok="checkPickTime"  style="width:15rem;" :value="chargeTime"/>
				</div>
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>缴费金额：</label>
					<a-input-number v-model="chargeFee" :min="0"  :precision="2" style="width:15rem;"/>
				</div>
			</a-modal>
			<a-drawer title="单价修改历史查看" :visible="showPriceUpdateLogListFlag" width="640" @close="showPriceUpdateLogListFlag = false" :destroyOnClose='true'>
				<ShowMeterPriceUpdateLogList :meterId="theMeterInfo.PID"/>
			</a-drawer>
		</div>
		<span class="titleInfo">缴费信息</span>
		<div id = "chargeLogDiv">
			<a-table size="small" :columns="chargeFeeLogColumns" :data-source="chargeFeeLogList" bordered :scroll="{y:210}" :pagination="false" style="color:black">
				<span slot="chargeTypeSlot" slot-scope="text, record">
					{{getChargeType(record.paytype)}}
				</span>
				<span slot="readTimeSlot" slot-scope="text, record">
					{{getTimeFormatter(record.ActionTime)}}
				</span>
				<span slot="theAction" slot-scope="text, record">
					<a-popconfirm title= "确定要撤销此次缴费记录?" ok-text="确定" cancel-text="取消" @confirm="cancelPay(record)">
						<a-button size="small"  type="link">撤销</a-button>
					</a-popconfirm>
					<a-button size="small"  type="link" @click="chargePrint(record)">收费打印</a-button>
					<a-button size="small"  type="link" @click="detailPrint(record)">详单打印</a-button>
				</span>
			</a-table>
			<a-modal title="请输入监督密码" :visible="showPasswordFlag1" :confirmLoading="chargeLogLoading"
							@ok="cancelPaySubmit" @cancel="showPasswordFlag1 = false">
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>监督密码：</label>
					<a-input-password v-model="theSupervisePassword"  style="width:15rem;" :allowClear="true"/>
				</div>
			</a-modal>
		</div>
		<span class="titleInfo">扣费信息</span>
		<div id = "deductLogDiv">
			<a-table size="small" :columns="deductLogColumns" :data-source="deductLogList" bordered :scroll="{y:210}" :pagination="false" :loading="deductLogLoading" >
				<span slot="actionTimeSlot" slot-scope="text, record">
					{{getTimeFormatter(record.ActionTime)}}
				</span>
				<span slot="useCountSlot" slot-scope="text, record">
					{{getUseCount(record)}}
				</span>
				<span slot="theAction" slot-scope="text, record">
					<a-popconfirm title= "确定要撤销此扣费信息?" ok-text="确定" cancel-text="取消" @confirm="cancelDeduct(record)">
						<a-button size="small"  type="link">撤销</a-button>
					</a-popconfirm>
					<a-button size="small"  type="link" @click="minusDeRead(record)">减免</a-button>
					<a-button size="small"  type="link" @click="showMinusDeReadList(record)">减免历史</a-button>
					<a-button size="small"  type="link" @click="toVirtual(record)">转到虚表</a-button>
				</span>
			</a-table>
			<a-modal title="请输入监督管理员密码" :visible="showPasswordFlag2" :confirmLoading="deductLogLoading"
							@ok="cancelDeductSubmit" @cancel="showPasswordFlag2 = false">
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>管理员密码：</label>
					<a-input-password v-model="theAdminPassword"  style="width:15rem;" :allowClear="true"/>
				</div>
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>监督密码：</label>
					<a-input-password v-model="theSupervisePassword"  style="width:15rem;margin-left: 0.9375rem;" :allowClear="true"/>
				</div>
			</a-modal>
			<a-modal title="水费减免" :visible="minusDereadFlag" :confirmLoading="minusDereadLoading"
							@ok="minusDereadSubmit" @cancel="minusDereadFlag = false">
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>当前用量：</label>
					<a-input v-model="theCurrentUseCount" :disabled="true" style="width:15rem;"/>
				</div>
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>减免吨数：</label>
					<a-input-number  v-model="theMinusDeread" :min ="0" :max = "theCurrentUseCount" :precision="0" style="width:15rem;" :allowClear="true"/>
				</div>
			</a-modal>
			<a-modal title="转到虚表" :visible="toVirtualFlag" :confirmLoading="toVirtualFlagLoading"
							@ok="toVirtualSubmit" @cancel="toVirtualFlag = false">
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>当前用量：</label>
					<a-input v-model="theCurrentUseCount" :disabled="true" style="width:15rem;"/>
				</div>
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>转入吨数：</label>
					<a-input-number  v-model="toVirtualCount" :min ="0" :max = "theCurrentUseCount" :precision="0" style="width:15rem;" :allowClear="true"/>
				</div>
			</a-modal>
			<a-modal title="预后付费转换" :visible="changePrepaySignFlag" :destroyOnClose="true"
							@ok="changePrePaySign" @cancel="changePrepaySignFlag = false">
				<div  class="chargeDiv" style="margin-top: 0.75rem;">
					<label>请输入密码：</label>
					<a-input-password v-model="changePrePaySignPwd"  style="width:22rem;" :allowClear="true"/>
				</div>
			</a-modal>
			<a-drawer title="减免历史查看" :visible="showMinusDereadLogListFlag" width="640" @close="showMinusDereadLogListFlag = false" :destroyOnClose='true'>
				<showMinusDereadLogList :mdlId="theDeductLog.MDID" :customerId="theCustomerInfo.pId" />
			</a-drawer>
		</div>
		<div id="statisDiv">
			<ve-histogram :data="chartData"  :settings="settings" v-if="chartData.rows.length>0" :extend = "extend"></ve-histogram>
		</div>
		<vxe-modal ref="mModal" v-model="showPrePaySignLogFlag" title="预后付费转换历史" width="1000" height="800"
								 destroy-on-close :mask="true" position="center">
				<ShowPrePaySignChangeLog/>
		</vxe-modal>
	</div>
</template>
<script>
	import moment from 'moment';
	import UpdateCustomerInfo from '../components/UpdateCustomerInfo.vue';
	import showMinusDereadLogList from '../components/ShowMinusDeteadLogList.vue'
	import ShowMeterPriceUpdateLogList from '../components/ShowMeterPriceUpdateLogList.vue'
	import ShowPrePaySignChangeLog from '../components/ShowPrePaySignChangeLog.vue'
	export default{
		components:{
			UpdateCustomerInfo,
			showMinusDereadLogList,
			ShowMeterPriceUpdateLogList,
			ShowPrePaySignChangeLog,
		},
		data(){
			var self = this;
			window.addEventListener('keydown', self.keyDown);
			const  meterColumns = [
					{
						title: '集中器',
						dataIndex: 'GPRSAddr',
						className:'v-cell',
						align:'center',
						slots: { title: 'customTitle' },
					},
					{
						title: '铅封号',
						dataIndex: 'qfh',
						className:'v-cell',
						align:'center',
					},
					{
						title: '钢印号',
						dataIndex: 'SteelNum',
						className:'v-cell',
						align:'center',
						
					},
					{
						title: '采集器地址',
						dataIndex: 'CollectorAddr',
						className:'v-cell',
						align:'center',
					},
					{
						title: '表地址',
						dataIndex: 'MeterAddr',
						className:'v-cell',
						align:'center',
					},
					{
						title: '虚实表',
						dataIndex: 'MeterSolid',
						scopedSlots: { customRender: 'meterSolidSlot' },
						className:'v-cell',
						align:'center',
					},
					{
						title: '表类型',
						dataIndex: 'MeterTypeName',
						className:'v-cell',
						align:'center',
					},
					{
						title: '单价',
						dataIndex: 'PriceKindName',
						className:'v-cell',
						align:'center',
					},
					{
						title: '扣费读数',
						dataIndex: 'DeRead',
						className:'v-cell',
						align:'center',
					},
					{
						title: '阶梯起始',
						dataIndex: 'destartread',
						className:'v-cell',
						align:'center',
					},
					{
						title: '表读数',
						dataIndex: 'readdata',
						className:'v-cell',
						align:'center',
					},
					{
						title: '抄表时间',
						dataIndex: 'readtime',
						scopedSlots:{customRender:'readTimeSlot'},
						className:'v-cell',
						align:'center',
						width:130,
					},
					{
						title: '换表底数',
						dataIndex: 'changend',
						className:'v-cell',
						align:'center',
					},
					{
						title: '操作',
						width:180,
						dataIndex: 'pId',
						scopedSlots: { customRender: 'theAction' },
						className:'v-cell',
						align:'center',
					},	
			];
			const chargeFeeLogColumns = [
				{
					title: '#',
					dataIndex: 'index',
					key: 'index',
					align: 'center',
					width: 50,
					customRender: (text,record,index) => `${index+1}`,
				},
				{
					title: '用户号',
					dataIndex: 'customerNum',
					className:'v-cell',
					align:'center',
				},
				{
					title: '用户名',
					dataIndex: 'CustomerName',
					className:'v-cell',
					align:'center',
				},
				{
					title: '地址',
					dataIndex: 'CustomerAddr',
					className:'v-cell',
					align:'center',
					ellipsis:true,
				},
				{
					title: '缴费金额',
					dataIndex: 'Amount',
					className:'v-cell',
					align:'center',
				},
				{
					title: '缴费时间',
					dataIndex: 'ActionTime',
					className:'v-cell',
					align:'center',
					scopedSlots:{customRender:'readTimeSlot'},
					width:130,
				},
				{
					title: '收费员',
					dataIndex: 'AdminName',
					className:'v-cell',
					align:'center',
				},
				{
					title: '缴费渠道',
					dataIndex: 'paytype',
					scopedSlots: { customRender: 'chargeTypeSlot' },
					className:'v-cell',
					align:'center',
				},
				{
					title: '流水号',
					dataIndex: 'payid',
					className:'v-cell',
					align:'center',
				},
				{
					title: '操作',
					dataIndex: 'pId',
					width:200,
					scopedSlots: { customRender: 'theAction' },
					className:'v-cell',
					align:'center',
				},	
				
			];
			const deductLogColumns = [
				{
					title: '#',
					dataIndex: 'index',
					key: 'index',
					align: 'center',
					width: 50,
					className:'v-cell',
					customRender: (text,record,index) => `${index+1}`,
				},
				{
					title: '集中器',
					dataIndex: 'GPRSAddr',
					className:'v-cell',
					align:'center',
					ellipsis:true,
				},
				{
					title: '表地址',
					dataIndex: 'MeterAddr',
					className:'v-cell',
					align:'center',
					ellipsis:true,
				},
				{
					title: '单价',
					dataIndex: 'PriceKindName',
					className:'v-cell',
					align:'center',
				},
				{
					title: '扣费读数',
					dataIndex: 'LastDeRead',
					className:'v-cell',
					align:'center',
				},
				{
					title: '表读数',
					dataIndex: 'MeterRead',
					className:'v-cell',
					align:'center',
				},
				{
					title: '换表底数',
					dataIndex: 'changend',
					className:'v-cell',
					align:'center',
				},
				{
					title: '扣费时间',
					dataIndex: 'ActionTime',
					scopedSlots:{customRender:'actionTimeSlot'},
					className:'v-cell',
					align:'center',
					width:130,
				},
				{
					title: '用量',
					scopedSlots:{customRender:'useCountSlot'},
					className:'v-cell',
					align:'center',
				},
				{
					title: '阶梯',
					dataIndex: 'formula',
					className:'v-cell',
					align:'center',
				},
				{
					title: '减免',
					dataIndex:'minusderead',
					className:'v-cell',
					align:'center',
				},
				{
					title: '转到虚表',
					dataIndex:'tovirtual',
					className:'v-cell',
					align:'center',
				},
				{
					title: '扣费金额',
					dataIndex:'DeMoney',
					className:'v-cell',
					align:'center',
				},
				{
					title: '操作',
					dataIndex: 'PID',
					width:230,
					scopedSlots: { customRender: 'theAction' },
					align:'center',
					className:'v-cell',
				},	
			];
			this.settings = {
				labelMap: {
					'monthData': '用量',
					'monthIndex': '统计月份',
				},
			}
			return {
				changePrePaySignPwd:null,
				changePrepaySignFlag:false,
				deductLogColumns,
				meterColumns,
				chargeFeeLogColumns,
				chargeTime:null,
				chargeFeeLogList:[],
				deductLogList:[],
				neighborList:[],
				priceList:[],
				theNeighbor:undefined,
				customerNum:null,
				alipayNum:null,
				icCard:null,
				searchNumFlag:false,
				searchICCardFlag:false,
				theCustomerInfo:{},
				theMeterInfo:{},
				theMeterList:[],
				thePrice:{},
				showUpdateCustomerInfoFlag:false,
				confirmLoading:false,
				themodal:null,
				lastQueryType:0,
				showUpdateDereadFlag:false,
				confirmLoading1:false,
				theDeread:null,
				showChargeFlag:false,
				confirmLoading2:false,
				chargeFee:null,
				chargeLogLoading:false,
				deductLogLoading:false,
				showPasswordFlag1:false,
				showPasswordFlag2:false,
				theChargeFeeLog:{},
				theDeductLog:{},
				theSupervisePassword:null,
				theAdminPassword:null,
				minusDereadFlag:false,
				minusDereadLoading:false,
				theCurrentUseCount:0,
				theMinusDeread:null,
				toVirtualFlag:false,
				toVirtualFlagLoading:false,
				toVirtualCount:null,
				showMinusDereadLogListFlag:false,
				showPriceUpdateLogListFlag:false,
				showPrePaySignLogFlag:false,
				chartData:{
					 columns: ['monthIndex','monthData'],
					 rows:[],
				},
				extend:{
					title:{
						text:'',
						x:'left',
						y:'top',
					},
				},
			}
		},
		methods:{
			keyDown(e) {
				if (e.keyCode == 13) {
						this.queryCustomerByNum();
				}
			},
			closeUpdateDereadModal:function(){
				this.showUpdateDereadFlag = false;
			},
			closeChargeModal:function(){
				this.showChargeFlag = false;
				this.chargeFee = null;
				this.chargeTime = null;
			},
			showPriceUpdateLogList:function(item){
				this.showPriceUpdateLogListFlag = true;
				this.theMeterInfo = item;
			},
			showMinusDeReadList:function(item){
				this.showMinusDereadLogListFlag = true;
				this.theDeductLog = item;
			},
			cancelDeduct:function(item){
				this.theDeductLog = item;
				this.showPasswordFlag2 = true;
			},
			cancelDeductSubmit:function(){
				if(this.theSupervisePassword == null || this.theSupervisePassword.length == 0){
					this.$message.error('请输入监督密码');
					return ;
				}
				if(this.theAdminPassword == null || this.theAdminPassword.length == 0){
					this.$message.error('请输入管理员密码');
					return ;
				}
				this.deductLogLoading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_CANCEL_DEDUCT_URL);
				let param = {
					adminPassword:this.theAdminPassword,
					supervisePwd:this.theSupervisePassword,
					theId:this.theDeductLog.MDID,
					neighborId:this.theNeighbor.key,
					customerId:this.theCustomerInfo.pId,
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.deductLogLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.showPasswordFlag2 = false;
						this.$message.success('撤销成功');
						if(this.lastQueryType == 0){
							this.queryCustomerByNum();
						}else{
							this.queryCustomerByCard();
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.deductLogLoading = false;
					console.log(error);
				});
			},
			minusDeRead:function(item){
				if (item.changend>0){
					this.theCurrentUseCount = item.MeterRead  + item.changend - item.LastDeRead;
				}else{
					this.theCurrentUseCount =  item.MeterRead  - item.LastDeRead;
				}
				this.theDeductLog = item;
				this.minusDereadFlag = true;
			},
			minusDereadSubmit:function(){
				if(this.theMinusDeread == null || this.theMinusDeread.length == 0){
					this.$message.error('请输入减免吨数');
					return ;
				}
				this.minusDereadLoading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_MINUS_DEREAD_URL);
				let param = {
					theId:this.theDeductLog.MDID,
					customerId:this.theCustomerInfo.pId,
					minusCount:this.theMinusDeread,
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.minusDereadLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.theMinusDeread = null;
						this.minusDereadFlag = false;
						this.$message.success('减免成功');
						if(this.lastQueryType == 0){
							this.queryCustomerByNum();
						}else{
							this.queryCustomerByCard();
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.minusDereadLoading = false;
					console.log(error);
				});
			},
			toVirtual:function(item){
				if (item.chanend>0){
					this.theCurrentUseCount = item.MeterRead  + item.changend - item.LastDeRead;
				}else{
					this.theCurrentUseCount =  item.MeterRead  - item.LastDeRead;
				}
				this.theDeductLog = item;
				this.toVirtualFlag = true;
			},
			toVirtualSubmit:function(){
				if(this.toVirtualCount == null || this.toVirtualCount.length == 0){
					this.$message.error('请输入转入虚表吨数');
					return ;
				}
				this.toVirtualFlagLoading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_TO_VIRTUAL_URL);
				let param = {
					theId:this.theDeductLog.MDID,
					customerId:this.theCustomerInfo.pId,
					count:this.toVirtualCount,
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.toVirtualFlagLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.toVirtualCount = null;
						this.toVirtualFlagLoading = false;
						this.$message.success('转入虚表成功');
						if(this.lastQueryType == 0){
							this.queryCustomerByNum();
						}else{
							this.queryCustomerByCard();
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.toVirtualFlagLoading = false;
					console.log(error);
				});
			},
			detailPrint:function(item){
				let theId = item.PID;
				let url = this.Api.getLastUrl('/report/chargeFeeDetail');
				let userId = this.Config.getUserLocal().pId;
				window.open(url+'?theId=' + theId+"&userId="+userId, "_blank");
			},
			chargePrint:function(item){
				let theId = item.PID;
				let url = this.Api.getLastUrl('/report/chargeFee');
				let userId = this.Config.getUserLocal().pId;
				window.open(url+'?theId=' + theId+"&userId="+userId, "_blank");
			},
			cancelPay:function(item){
				this.showPasswordFlag1 = true;
				this.theChargeFeeLog = item;
			},
			cancelPaySubmit:function(){
				if(this.theSupervisePassword == null || this.theSupervisePassword.length == 0){
					this.$message.error('请输入监督密码');
					return ;
				}
				this.chargeLogLoading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_CANCEL_CHARGE_URL);
				let param = {
					theSupervisePwd:this.theSupervisePassword,
					theId:this.theChargeFeeLog.PID,
					neighborId:this.theNeighbor.key
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.chargeLogLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.showPasswordFlag1 = false;
						this.$message.success('撤销成功');
						if(this.lastQueryType == 0){
							this.queryCustomerByNum();
						}else{
							this.queryCustomerByCard();
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.chargeLogLoading = false;
					console.log(error);
				});
			},
			checkPickTime:function(value){
				let date  = new Date(value);
				this.chargeTime = this.Config.formatDate(date);
			},
			doChargeSubmit:function(){
				if(this.chargeTime == null){
					this.$message.error('请选择缴费时间');
					return;
				}
				if(this.chargeFee == null){
					this.$message.error('请输入缴费金额');
					return;
				}
				this.confirmLoading2 = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_CHARGE_FEE_URL);
				let param = {
					customerId:this.theCustomerInfo.pId,
					chargeTime:this.Config.formatDate(new Date()),
					chargeFee:this.chargeFee
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.confirmLoading2 = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						let balance = result.balance;
						let theId = result.logId;
						this.closeChargeModal();
						if(this.lastQueryType == 0){
							this.queryCustomerByNum();
						}else{
							this.queryCustomerByCard();
						}
						let title = '缴费成功,余额'+balance;
						this.$message.success(title);
						this.chargeFeePrint(theId);
					}
				}).catch((error)=>{
					this.confirmLoading2 = false;
					console.log(error);
				});
			},
			chargeFeePrint:function(theId){
				let url = this.Api.getLastUrl('/report/chargeFee');
				let userId = this.Config.getUserLocal().pId;
				window.open(url+'?theId=' + theId+"&userId="+userId, "_blank");
			},
			updateDereadSubmit:function(){
				if(this.theDeread == null || this.theDeread.length == 0){
					this.$message.error('请输入新扣费读数');
					return;
				}
				this.confirmLoading1 = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_UPDATE_DEREAD_URL);
				let param = {
					meterId:this.theMeterInfo.PID,
					newDeRead:this.theDeread, 
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.confirmLoading1 = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('更新成功');
						this.showUpdateDereadFlag = false;
						if(this.lastQueryType == 0){
							this.queryCustomerByNum();
						}else{
							this.queryCustomerByCard();
						}
					}else{
						this.$message.error(msg);
					}
					
				}).catch((error)=>{
					this.confirmLoading1 = false;
					console.log(error);
				});
			},
			toBottom:function(){
			      this.$nextTick(()=>{
			        var scrollDom = document.getElementById('mainContainer');
			        scrollDom.scrollTop = scrollDom.scrollHeight;
			      });
			},
			showDeRead:function(item){
				this.theMeterInfo = item;
				let param = {meterId:this.theMeterInfo.PID};
				let url = this.Api.getLastUrl(this.Api.GET_METER_DEDUCT_STATIS_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.chartData.rows = result;
						this.extend.title.text = this.theMeterInfo.SteelNum+'扣费读数';
						this.toBottom();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			updateCustomerSubmit:function(){
				this.confirmLoading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_UPDATE_CUSTOMER_INFO_URL);
				let param = { 
									 customerId:this.theCustomerInfo.pId,
									 customerName:this.theCustomerInfo.customerName,
									 customerMobile:this.theCustomerInfo.customerMobile,
									 idNum:this.theCustomerInfo.nationalId,
									 fpRemark:this.theCustomerInfo.fpRemark,
									 };
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.confirmLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('更新成功');
						this.updateCustomerCancel();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.confirmLoading = false;
					console.log(error);
				});
				
			},
			updateCustomerCancel:function(){
				this.showUpdateCustomerInfoFlag = false;
				this.theDeread = null;
			},
			validIt:function(){
				if(this.theNeighbor == undefined){
					this.$message.error('请选择小区');
					return false;
				}
				if(this.customerNum == null && this.alipayNum == null){
					this.$message.error('请输入用户号或支付宝缴费号');
					return false;
				}
				if(this.customerNum == '' && this.alipayNum == null){
					this.$message.error('请输入用户号或支付宝缴费号');
					return false;
				}
				if(this.customerNum == null && this.alipayNum == ''){
					this.$message.error('请输入用户号或支付宝缴费号');
					return false;
				}
				if(this.customerNum == '' && this.alipayNum == ''){
					this.$message.error('请输入用户号或支付宝缴费号');
					return false;
				}
				if(this.customerNum != null && this.alipayNum != null && this.customerNum.length && this.alipayNum.length){
					this.$message.error('用户号和支付宝缴费号只能输入一个');
					return false;
				}
				return true;
			},
			queryCustomerByNum:function(){
				if(this.validIt()){
					this.lastQueryType = 0;
					this.searchNumFlag = true;
					let param = {neighborId:this.theNeighbor.key,customerNum:this.customerNum,alipayNum:this.alipayNum};
					let url = this.Api.getLastUrl(this.Api.CHARGE_GET_CUSTOMER_INFO_URL);
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.searchNumFlag = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							if(Object.keys(result).length>0){
								this.theCustomerInfo = result.customerInfo;
								if(result.meterList!=null && result.meterList.length>0){
									this.theMeterList = result.meterList;
									this.theMeterInfo = this.theMeterList[0];
								}
								this.resetCustomerInfo();
								this.queryChargeLogList();
								this.queryDeductLogList();
							}else{
								this.$message.error('无此用户');
							}
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.searchNumFlag = false;
						console.log(error);
					});
				}
			},
			changePrePaySign:function(){
				if(this.changePrePaySignPwd == null){
					this.$message.error('请输入密码');
					return;
				}
				if(this.changePrePaySignPwd != this.Config.PREPAY_SIAN_PWD){
					this.$message.error('密码错误');
					return;
				}
				this.changePrepaySignFlag = false;
				this.changePrePaySignPwd = null;
				if(Object.keys(this.theCustomerInfo).length){
					let prePaySign = this.theCustomerInfo.prePaySign;
					var str = null;
					if(prePaySign == 1){
						str = "确定要修改为后付费?";
						prePaySign = 0;
					}else{
						str = "确定要修改为预付费?";
						prePaySign = 1;
					}
					this.themodal = this.$confirm({
						title:str,
						content:'',
						okType: 'info',
						centered:true,
						onOk: h=>{
							this.changePrePaySignSubmit(prePaySign);
						},
					});
				}else{
					this.$message.error('请先选择用户');
				}
			},
			changePrePaySignSubmit:function(prePaySign){
					this.themodal.destroy();
					let url = this.Api.getLastUrl(this.Api.CHARGE_CHANGE_PREPAYSIGN_URL);
					let param = { customerId:this.theCustomerInfo.pId,prePaySign:prePaySign};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success('转换成功');
							if(this.lastQueryType == 0){
								this.queryCustomerByNum();
							}else{
								this.queryCustomerByCard();
							}
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(error);
					});
			},
			doCharge:function(){
				if(Object.keys(this.theCustomerInfo).length){
					let prePaySign = this.theCustomerInfo.prePaySign;
					if(prePaySign == 0){
						this.showChargeFlag = false;
						this.$message.error('后付费用户不可在此交费');
					}else{
						this.showChargeFlag = true;
						this.chargeTime = this.getNowTime();
					}
				}else{
					this.showChargeFlag = false;
					this.$message.error('请先选择用户');
				}
			},
			queryCustomerByCard:function(){
				if(this.theNeighbor == undefined){
					this.$message.error('请选择小区');
					return ;
				}
				if(this.icCard == null){
					this.$message.error('请输入IC卡号');
					return ;
				}
				this.lastQueryType = 1;
				this.searchICCardFlag = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_GET_CUSTOMER_BY_IDCARD_URL);
				let param = {neighborId:this.theNeighbor.key,idCard:this.icCard};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.searchICCardFlag = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						if(Object.keys(result).length>0){
							this.theCustomerInfo = result.customerInfo;
							this.theMeterList = result.meterList;
							this.theMeterInfo = this.theMeterList[0];
							this.resetCustomerInfo();
							this.queryChargeLogList();
							this.queryDeductLogList();
						}else{
							this.$message.error('无此用户');
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.searchICCardFlag = false;
					console.log(error);
				});
			},
			updatePrice:function(item){
				this.theMeterInfo = item;
				let url = this.Api.getLastUrl(this.Api.CHARGE_UPDATE_METER_PRICE_URL);
				let param = {meterId:this.theMeterInfo.PID,priceId:this.thePrice.key,oldPriceId:item.PriceKindID};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('更新单价成功');
						if(this.lastQueryType == 0){
							this.queryCustomerByNum();
						}else{
							this.queryCustomerByCard();
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			resetCustomerInfo:function(){
					this.theCustomerInfo.houseKindName = this.Config.getValueByNameFromList(this.theCustomerInfo.houseKindId,this.Config.getHouseKindList());
					this.theCustomerInfo.prePaySignName = this.Config.getValueByNameFromList(this.theCustomerInfo.prePaySign,this.Config.getPrepaySignList()); 
					if(this.theMeterInfo!=undefined && this.theMeterInfo.MeterState){
						this.theMeterInfo.MeterStateName = this.Config.getValueByNameFromList(this.theMeterInfo.MeterState,this.Config.getMeterStateList());
					}else{
						this.theMeterInfo.MeterStateName = '';
					}
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryPriceList:function(){
				let url = this.Api.getLastUrl(this.Api.BASIC_PRICE_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.priceList = result;
						this.thePrice.key = this.priceList[0].PID;
						this.thePrice.value = this.priceList[0].PID;
						this.thePrice.label = this.priceList[0].PriceKindName;
	
						
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
			updateDeRead:function(item){
				this.theMeterInfo = item;
				this.showUpdateDereadFlag = true;
				this.theDeread = this.theMeterInfo.DeRead;
			},
			queryDeductLogList:function(){
				let url = this.Api.getLastUrl(this.Api.CHARGE_DEDUCT_LOG_LIST);
				let param = {customerId:this.theCustomerInfo.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.deductLogList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			
			queryChargeLogList:function(){
				let url = this.Api.getLastUrl(this.Api.CHARGE_CHARGE_LOG_LIST_URL);
				let param = {customerId:this.theCustomerInfo.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.chargeFeeLogList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			getDeductionStyle:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getDeductionStyleList());
			},
			getOpenType:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getOpenList());
			},
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
			getSolidType:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getSolidList());
			},
			getChargeType:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getPayTypeList());
			},
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
			getUseCount:function(item){
				if(item.changend>0){
					return item.MeterRead+item.changend-item.LastDeRead;
				}else{
					return item.MeterRead-item.LastDeRead;
				}
			},
			drawLine:function(result){
			},
			getNowTime:function(){
				return moment(this.Config.formatDate(new Date),'YYYY-MM-DD HH:mm:ss');
			}
		},
		created() {
			this.queryNeighbors();
			this.queryPriceList();
		},
		destroyed(){
			window.removeEventListener('keydown', this.keyDown);
		},
	}
</script>

<style scoped="scoped">
	.titleInfo{
		color: black;
		font-weight: bold;
		font-size: 0.9375rem;
		padding-left: 0.7rem;
	}
	#customerInfoDiv{
		padding: 1.5rem;
		margin: 0.8rem 0.5rem;
		border: 0.0625rem solid #dcdee2;
		font-size: 0.6875rem;
	}
	#meterInfoDiv{
		margin: 0.8rem 0.5rem;
		font-size: 0.6875rem;
	}
	#chargeLogDiv{
		margin: 0.8rem 0.5rem;
		font-size: 0.6875rem;
	}
	#deductLogDiv{
		margin: 0.8rem 0.5rem;
		font-size: 0.6875rem;
	}
	.chargeDiv{
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0 0.625rem;
		font-size: 0.6875rem;
	}
	#statisDiv{
		padding: 0 0.625rem;
		margin-top: 1.25rem;
		font-size: 0.6875rem;
	}
	 /deep/  .ant-table-thead > tr > th {
	    color: #333;
		font-weight: bold;
		background-color: #F8F8F9;
	  }
</style>
